module.exports = __webpack_public_path__ + "static/media/cookie.26f5828c.svg";